export default "__VITE_ASSET__C$Tqi3dY__"